import React from "react";

const MobileContinueButton = props => {
  return (
    <button
      className="btn btn-warning btn-lg"
      value={"continue"}
      onClick={() => {
        props.onClick();
      }}
      disabled={props.disabled ? props.disabled : null}
    >
      {props.title.text}
    </button>
  );
};

export default MobileContinueButton;
